<script setup>
  import MainButton from '@/Components/MainButton.vue';

  // Define props for all content
  const props = defineProps({
    imageVector: {
      type: String
      //   default: '/images/welcome/GuyWorkingout.png'
    },
    imageRectangleTop: {
      type: String,
      required: true
    },
    imageRectangleBottom: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    title2: {
      type: String,
      required: false
    },
    subtitle2: {
      type: String,
      required: false
    },
    title3: {
      type: String,
      required: false
    },
    subtitle3: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: true
    },
    description2: {
      type: String,
      required: false
    },
    buttonText: {
      type: String,
      default: 'Learn More'
    },
    buttonLink: {
      type: String,
      default: '/'
    }
  });
</script>

<template>
  <div
    class="xs:flex-col mx-auto flex max-w-4xl flex-col flex-col-reverse px-2 sm:flex-row"
  >
    <!-- Left Image Section -->
    <div class="mx-auto mt-10 flex flex-row items-center sm:w-1/2 md:mt-0">
      <!-- Main Vector Image -->
      <svg
        width="283"
        height="326"
        viewBox="0 0 283 326"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- Define the custom mirrored shape -->
        <defs>
          <clipPath id="custom-mirrored-shape">
            <path
              d="M211.708 325.262L158.052 320.733C46.2077 311.293 -26.952 199.24 9.41374 93.0762C12.5657 83.8746 19.3339 76.3557 28.1557 72.2556L167.806 7.3501C213.001 -13.6553 265.25 17.0304 268.904 66.725L282.747 255.005C285.708 295.279 251.956 328.659 211.708 325.262Z"
              transform="scale(-1, 1) translate(-283, 0)"
            />
          </clipPath>
        </defs>

        <!-- Use the custom mirrored clipping path on the image -->
        <image
          :href="imageVector"
          width="283"
          height="326"
          clip-path="url(#custom-mirrored-shape)"
          preserveAspectRatio="xMidYMid slice"
          alt="Vector Image"
        />
      </svg>

      <!-- Side Rectangle Images -->
      <div class="ml-6 flex flex-col">
        <img
          :src="imageRectangleTop"
          alt="Top Rectangle Image"
          class="aspect-[3/4] w-24 rounded-full object-cover md:w-32"
        />
        <img
          :src="imageRectangleBottom"
          alt="Bottom Rectangle Image"
          class="aspect-square w-32 rounded-[50%_50%_10px_50%] object-cover md:w-52"
        />
      </div>
    </div>

    <!-- Right Content Section -->
    <div class="mx-auto sm:w-1/2">
      <div class="mx-auto mt-6 text-2xl md:ml-10 md:text-4xl">
        <div
          class="custom-margin mb-2 flex flex-row justify-center text-center font-title tracking-wide sm:-ml-16 md:-ml-0 md:flex-col md:text-left md:text-4xl"
        >
          <p class="">{{ title }}</p>
          <p class="ml-3 font-semibold md:ml-6">{{ subtitle }}</p>
        </div>
        <div
          class="custom-margin2 mb-2 flex flex-row justify-center font-title tracking-wide md:flex-col"
        >
          <p class="md:ml-14">{{ title2 }}</p>
          <p class="ml-3 text-center font-semibold md:ml-6">{{ subtitle2 }}</p>
        </div>
        <div
          class="mb-2 flex flex-row justify-center text-center font-title tracking-wide md:flex-col"
        >
          <p class="text-center">{{ title3 }}</p>
          <p class="ml-3 text-center font-semibold md:ml-16">{{ subtitle3 }}</p>
        </div>
        <p class="mr-8 mt-4 text-center text-sm" v-html="description"></p>
        <p class="mr-8 mt-4 text-center text-sm">{{ description2 }}</p>
      </div>
      <div class="flex w-full justify-center">
        <MainButton class="mx-auto mt-10 h-10 text-sm" :href="buttonLink">
          {{ buttonText }}
        </MainButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
  @media (min-width: 640px) and (max-width: 741px) {
    .custom-margin {
      margin-left: -54px;
    }

    .custom-margin2 {
      margin-left: -40px;
    }
  }
</style>
